module.exports = __webpack_public_path__ + "img/93976.52c94993.svg";